export default "__VITE_ASSET__518ad2d0__"